import { render, staticRenderFns } from "./TestAgms.vue?vue&type=template&id=5667631f"
import script from "./TestAgms.vue?vue&type=script&lang=js"
export * from "./TestAgms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports